import { Step, StepLabel, Stepper } from '@mui/material';
import React from 'react';

const CartProgressIndicator = ({ activeStep }) => {
  const steps = ['Resumo', 'Informações', 'Confirmação'];
  return (
    <Stepper
      alternativeLabel
      activeStep={activeStep}
      sx={{ marginTop: { md: 4 }, marginBottom: { xs: 5, md: 6 } }}
    >
      {steps.map((step) => (
        <Step key={step}>
          <StepLabel>{step}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default CartProgressIndicator;
